import React, { useEffect, useState, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { utrBankStatementArr, maxFileSize } from "../../../utils/constant";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import { modalEventListenerAllowXScroll } from "../../../utils/ModalEventListener";
import { axios_instance } from "../../../api/axios_instance";
import LoadingModal from "../../../layouts/LoadingModal";
import Modal from "../../../layouts/ModalWrapper";

const UpdateUTRModal = ({ closeUTRModal, showUTRModal }) => {
  const [bank, setBank] = useState("");
  const [file, setFile] = useState({});

  const [loading, setIsLoading] = useState(false);
  const ref = useRef();

  useEffect(() => {
    setBank("");
    setFile({});
    return modalEventListenerAllowXScroll(ref, closeUTRModal);
  }, [closeUTRModal]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => {
      if (files.length) {
        setFile(files[0]);
        toast.success(`${files[0].name} has been uploaded, to complete process click on
      "Complete Upload"`);
      } else {
        toast.error("Unsupported format. Please upload a CSV file.");
      }
    },
    accept: { "text/csv": [".csv"] },
    maxFiles: 1,
    maxSize: maxFileSize,
    multiple: false,
  });

  const UploadUTRSheet = async () => {
    toast.dismiss();

    if (!bank) {
      return toast.error("Bank is mandatory");
    }

    if (!Object.keys(file).length) {
      return toast.error("Please upload the file to proceed");
    }

    setIsLoading(true);

    const data = new FormData();

    data.append("bank", bank);
    data.append("file", file);

    try {
      const response = await axios_instance({
        url: "/dts/bulkUtrUpdate",
        method: "POST",
        data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response) {
        const {
          url,
          totalErrorCount,
          alreadyExistCount,
          totalUpdatedCount,
          totalDataCount,
        } = response.data.data;

        const message = `${totalUpdatedCount} of ${totalDataCount} updated, ${totalErrorCount} error identified, ${alreadyExistCount} already updated.`;

        if (totalErrorCount) {
          window.open(url);
          toast.error(`Found error in sheet. ${message}`);
        } else {
          toast.success(`Successfully ${message}`);
        }
      }

      closeUTRModal();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal onClose={closeUTRModal} show={showUTRModal}>
      {loading && <LoadingModal />}

      <div className="modal-wrapper">
        <div className="utr-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={closeUTRModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Update UTR Number</h4>
          </div>

          <div className="modal-body clearfix doc-upload-wrapper">
            <div className="form-group clearfix">
              <div className="row">
                <div className="col-md-5 ">
                  <label className="fnt14">
                    Select Bank Statement <span className="col-red">*</span>
                  </label>
                </div>
                <div className="col-md-6">
                  <SingleSelectDropDown
                    dataArr={utrBankStatementArr}
                    handleChange={(e) => setBank(e.target.value)}
                    name="utr_bank_statement"
                    disabled={false}
                    required={false}
                    value={bank}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-5 ">
                  <label className="fnt14">
                    Accepted Format : <span className="col-red">.csv</span>
                  </label>
                </div>
                <div className="col-md-12">
                  <div>
                    <form
                      className="dropzone dd-zone dz-clickable"
                      style={{ minHeight: "180px" }}
                      id="utr_uploader"
                    >
                      <div
                        className="dz-default dz-message"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        Drop file here to upload
                      </div>
                    </form>
                    <div className="clearfix btn-upload-wrapper">
                      <div className="ufn-wrapr">
                        <p className="ufn" id="caseFileUploadDiv">
                          {file.name}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn rc-btn_primary btn-lg"
              id="completeUploadBtn"
              value=""
              onClick={UploadUTRSheet}
            >
              Complete Upload
            </button>
          </div>
        </div>
      </div>
    </Modal>
    // document.querySelector(".myPortalModalDiv")
  );
};

export default UpdateUTRModal;
